import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface DialogMathWarningProps {
    isOpen: boolean
    closeDialog: () => void
    onConfirm: () => void
}

export const DialogMathWarning = ({
    isOpen,
    closeDialog,
    onConfirm,
}: DialogMathWarningProps) => {
    return (
        <Dialog open={isOpen} onClose={closeDialog} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Warning

                <IconButton onClick={closeDialog}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    Please manually select matching sections for <b>MATH 100 / 101</b> (A / B / C etc.) after adding the course.
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onConfirm} variant="contained">
                    I understand
                </Button>
            </DialogActions>
        </Dialog>
    )
}